import { render, staticRenderFns } from "./TableNew.vue?vue&type=template&id=5c62dffe&scoped=true"
import script from "./TableNew.vue?vue&type=script&lang=js"
export * from "./TableNew.vue?vue&type=script&lang=js"
import style0 from "./TableNew.vue?vue&type=style&index=0&id=5c62dffe&prod&scoped=true&lang=css"
import style1 from "./TableNew.vue?vue&type=style&index=1&id=5c62dffe&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c62dffe",
  null
  
)

export default component.exports